package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Northern Mariana Islands Flag (20x15dp)
 *
 * - ISO Alpha-2: MP
 * - ISO Alpha-3: MNP
 * - ISO Numeric: 580
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.NorthernMarianaIslands: ImageVector by lazy {
    ImageVector.Builder(
        name = "Northern Mariana Islands:MP:MNP:580:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2993EC)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(21.25f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF1F9FF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.883f, 7.24f)
                curveTo(3.883f, 10.547f, 6.622f, 13.229f, 10f, 13.229f)
                curveTo(13.378f, 13.229f, 16.117f, 10.547f, 16.117f, 7.24f)
                curveTo(16.117f, 3.932f, 13.378f, 1.25f, 10f, 1.25f)
                curveTo(6.622f, 1.25f, 3.883f, 3.932f, 3.883f, 7.24f)
                close()
                moveTo(14.787f, 7.24f)
                curveTo(14.787f, 9.828f, 12.644f, 11.927f, 10f, 11.927f)
                curveTo(7.356f, 11.927f, 5.213f, 9.828f, 5.213f, 7.24f)
                curveTo(5.213f, 4.651f, 7.356f, 2.552f, 10f, 2.552f)
                curveTo(12.644f, 2.552f, 14.787f, 4.651f, 14.787f, 7.24f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(4.415f, 7.24f)
                curveTo(4.415f, 10.26f, 6.915f, 12.708f, 10f, 12.708f)
                curveTo(13.085f, 12.708f, 15.585f, 10.26f, 15.585f, 7.24f)
                curveTo(15.585f, 4.219f, 13.085f, 1.771f, 10f, 1.771f)
                curveTo(6.915f, 1.771f, 4.415f, 4.219f, 4.415f, 7.24f)
                close()
                moveTo(15.319f, 7.24f)
                curveTo(15.319f, 10.116f, 12.938f, 12.448f, 10f, 12.448f)
                curveTo(7.062f, 12.448f, 4.681f, 10.116f, 4.681f, 7.24f)
                curveTo(4.681f, 4.363f, 7.062f, 2.031f, 10f, 2.031f)
                curveTo(12.938f, 2.031f, 15.319f, 4.363f, 15.319f, 7.24f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFDDA33)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10f, 1.38f)
                curveTo(9.933f, 1.519f, 9.899f, 1.717f, 9.899f, 1.974f)
                curveTo(9.899f, 2.23f, 9.8f, 2.486f, 9.601f, 2.743f)
                curveTo(9.564f, 2.461f, 9.546f, 2.204f, 9.546f, 1.974f)
                curveTo(9.546f, 1.743f, 9.697f, 1.545f, 10f, 1.38f)
                close()
                moveTo(11.398f, 1.592f)
                curveTo(11.301f, 1.712f, 11.223f, 1.897f, 11.166f, 2.147f)
                curveTo(11.108f, 2.397f, 10.953f, 2.625f, 10.702f, 2.83f)
                curveTo(10.73f, 2.546f, 10.77f, 2.292f, 10.822f, 2.068f)
                curveTo(10.873f, 1.843f, 11.065f, 1.685f, 11.398f, 1.592f)
                close()
                moveTo(12.358f, 2.605f)
                curveTo(12.474f, 2.376f, 12.594f, 2.216f, 12.718f, 2.122f)
                curveTo(12.373f, 2.132f, 12.148f, 2.239f, 12.043f, 2.445f)
                curveTo(11.939f, 2.65f, 11.839f, 2.887f, 11.743f, 3.156f)
                curveTo(12.037f, 3.017f, 12.242f, 2.833f, 12.358f, 2.605f)
                close()
                moveTo(13.87f, 2.927f)
                curveTo(13.728f, 2.991f, 13.575f, 3.121f, 13.411f, 3.317f)
                curveTo(13.246f, 3.513f, 13.005f, 3.646f, 12.688f, 3.715f)
                curveTo(12.841f, 3.475f, 12.992f, 3.267f, 13.14f, 3.09f)
                curveTo(13.288f, 2.913f, 13.531f, 2.859f, 13.87f, 2.927f)
                close()
                moveTo(14.267f, 4.248f)
                curveTo(14.472f, 4.093f, 14.65f, 4.001f, 14.802f, 3.971f)
                curveTo(14.488f, 3.829f, 14.239f, 3.827f, 14.055f, 3.966f)
                curveTo(13.871f, 4.104f, 13.677f, 4.273f, 13.473f, 4.473f)
                curveTo(13.798f, 4.477f, 14.063f, 4.402f, 14.267f, 4.248f)
                close()
                moveTo(15.467f, 5.21f)
                curveTo(15.312f, 5.202f, 15.117f, 5.249f, 14.881f, 5.349f)
                curveTo(14.645f, 5.449f, 14.37f, 5.458f, 14.056f, 5.376f)
                curveTo(14.302f, 5.231f, 14.531f, 5.114f, 14.743f, 5.024f)
                curveTo(14.955f, 4.934f, 15.196f, 4.996f, 15.467f, 5.21f)
                close()
                moveTo(15.22f, 6.557f)
                curveTo(15.473f, 6.512f, 15.673f, 6.511f, 15.822f, 6.553f)
                curveTo(15.607f, 6.284f, 15.386f, 6.169f, 15.159f, 6.209f)
                curveTo(14.932f, 6.249f, 14.682f, 6.312f, 14.41f, 6.397f)
                curveTo(14.698f, 6.548f, 14.968f, 6.601f, 15.22f, 6.557f)
                close()
                moveTo(3.803f, 6.106f)
                curveTo(3.928f, 6.197f, 4.117f, 6.264f, 4.369f, 6.309f)
                curveTo(4.622f, 6.353f, 4.857f, 6.495f, 5.076f, 6.736f)
                curveTo(4.791f, 6.723f, 4.535f, 6.696f, 4.308f, 6.656f)
                curveTo(4.081f, 6.616f, 3.913f, 6.433f, 3.803f, 6.106f)
                close()
                moveTo(4.763f, 5.117f)
                curveTo(4.527f, 5.017f, 4.358f, 4.908f, 4.257f, 4.792f)
                curveTo(4.29f, 5.135f, 4.413f, 5.352f, 4.625f, 5.442f)
                curveTo(4.837f, 5.532f, 5.081f, 5.615f, 5.356f, 5.692f)
                curveTo(5.197f, 5.409f, 4.999f, 5.217f, 4.763f, 5.117f)
                close()
                moveTo(5.017f, 3.608f)
                curveTo(5.088f, 3.746f, 5.225f, 3.892f, 5.43f, 4.046f)
                curveTo(5.635f, 4.201f, 5.78f, 4.434f, 5.866f, 4.747f)
                curveTo(5.617f, 4.607f, 5.401f, 4.467f, 5.217f, 4.328f)
                curveTo(5.033f, 4.19f, 4.967f, 3.95f, 5.017f, 3.608f)
                close()
                moveTo(6.328f, 3.155f)
                curveTo(6.163f, 2.959f, 6.062f, 2.785f, 6.024f, 2.636f)
                curveTo(5.898f, 2.957f, 5.91f, 3.205f, 6.058f, 3.382f)
                curveTo(6.206f, 3.558f, 6.385f, 3.743f, 6.595f, 3.936f)
                curveTo(6.582f, 3.612f, 6.493f, 3.351f, 6.328f, 3.155f)
                close()
                moveTo(7.233f, 1.916f)
                curveTo(7.236f, 2.071f, 7.296f, 2.262f, 7.412f, 2.491f)
                curveTo(7.529f, 2.719f, 7.557f, 2.993f, 7.496f, 3.312f)
                curveTo(7.335f, 3.076f, 7.202f, 2.856f, 7.098f, 2.651f)
                curveTo(6.993f, 2.446f, 7.038f, 2.201f, 7.233f, 1.916f)
                close()
                moveTo(8.626f, 2.091f)
                curveTo(8.568f, 1.841f, 8.556f, 1.64f, 8.591f, 1.49f)
                curveTo(8.333f, 1.719f, 8.23f, 1.945f, 8.282f, 2.17f)
                curveTo(8.333f, 2.394f, 8.409f, 2.64f, 8.509f, 2.908f)
                curveTo(8.644f, 2.613f, 8.683f, 2.34f, 8.626f, 2.091f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFA7A7A7)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.116f, 3.594f)
                curveTo(8.887f, 3.594f, 8.717f, 3.806f, 8.766f, 4.03f)
                lineTo(9.007f, 5.134f)
                curveTo(9.029f, 5.231f, 9.088f, 5.312f, 9.168f, 5.362f)
                curveTo(9.094f, 5.419f, 9.043f, 5.504f, 9.031f, 5.603f)
                lineTo(8.164f, 12.882f)
                curveTo(8.148f, 13.015f, 8.208f, 13.146f, 8.325f, 13.213f)
                curveTo(8.651f, 13.399f, 9.359f, 13.75f, 10.066f, 13.75f)
                curveTo(10.774f, 13.75f, 11.482f, 13.399f, 11.808f, 13.213f)
                curveTo(11.925f, 13.146f, 11.985f, 13.015f, 11.969f, 12.882f)
                lineTo(11.102f, 5.603f)
                curveTo(11.09f, 5.504f, 11.039f, 5.419f, 10.965f, 5.362f)
                curveTo(11.045f, 5.312f, 11.104f, 5.231f, 11.126f, 5.134f)
                lineTo(11.367f, 4.03f)
                curveTo(11.416f, 3.806f, 11.246f, 3.594f, 11.017f, 3.594f)
                horizontalLineTo(9.116f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(4.075f, 7.508f)
                curveTo(4.107f, 7.405f, 4.218f, 7.347f, 4.324f, 7.378f)
                curveTo(4.429f, 7.41f, 4.488f, 7.519f, 4.456f, 7.622f)
                curveTo(4.4f, 7.801f, 4.4f, 8.064f, 4.462f, 8.409f)
                curveTo(4.485f, 8.542f, 4.513f, 8.644f, 4.548f, 8.734f)
                curveTo(4.562f, 8.77f, 4.576f, 8.803f, 4.595f, 8.844f)
                curveTo(4.586f, 8.825f, 4.633f, 8.924f, 4.644f, 8.949f)
                curveTo(4.704f, 9.084f, 4.73f, 9.203f, 4.73f, 9.376f)
                curveTo(4.73f, 9.484f, 4.641f, 9.571f, 4.531f, 9.571f)
                curveTo(4.42f, 9.571f, 4.331f, 9.484f, 4.331f, 9.376f)
                curveTo(4.331f, 9.257f, 4.316f, 9.192f, 4.278f, 9.104f)
                curveTo(4.269f, 9.084f, 4.226f, 8.992f, 4.232f, 9.005f)
                curveTo(4.209f, 8.957f, 4.192f, 8.916f, 4.174f, 8.871f)
                curveTo(4.131f, 8.758f, 4.097f, 8.632f, 4.069f, 8.476f)
                curveTo(3.997f, 8.076f, 3.997f, 7.755f, 4.075f, 7.508f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.133f, 10.112f)
                lineTo(7.561f, 11.864f)
                lineTo(8.469f, 8.928f)
                lineTo(5.972f, 7.075f)
                lineTo(9.104f, 7.012f)
                lineTo(10.133f, 4.115f)
                lineTo(11.162f, 7.012f)
                lineTo(14.294f, 7.075f)
                lineTo(11.797f, 8.928f)
                lineTo(12.705f, 11.864f)
                lineTo(10.133f, 10.112f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(15.975f, 7.768f)
                curveTo(15.942f, 7.665f, 15.831f, 7.607f, 15.726f, 7.639f)
                curveTo(15.62f, 7.67f, 15.561f, 7.78f, 15.593f, 7.883f)
                curveTo(15.649f, 8.061f, 15.649f, 8.325f, 15.587f, 8.67f)
                curveTo(15.564f, 8.802f, 15.536f, 8.904f, 15.501f, 8.994f)
                curveTo(15.488f, 9.03f, 15.473f, 9.063f, 15.454f, 9.104f)
                curveTo(15.463f, 9.086f, 15.416f, 9.184f, 15.405f, 9.21f)
                curveTo(15.345f, 9.345f, 15.319f, 9.463f, 15.319f, 9.636f)
                curveTo(15.319f, 9.744f, 15.408f, 9.832f, 15.519f, 9.832f)
                curveTo(15.629f, 9.832f, 15.718f, 9.744f, 15.718f, 9.636f)
                curveTo(15.718f, 9.518f, 15.733f, 9.452f, 15.771f, 9.365f)
                curveTo(15.78f, 9.344f, 15.824f, 9.252f, 15.817f, 9.266f)
                curveTo(15.84f, 9.218f, 15.858f, 9.177f, 15.875f, 9.131f)
                curveTo(15.918f, 9.018f, 15.953f, 8.893f, 15.98f, 8.737f)
                curveTo(16.052f, 8.337f, 16.052f, 8.015f, 15.975f, 7.768f)
                close()
            }
            path(
                stroke = SolidColor(Color(0xFF73BE4A)),
                strokeLineWidth = 0.625f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(10.038f, 1.967f)
                curveTo(10.038f, 1.967f, 10.766f, 2.291f, 10.451f, 2.802f)
            }
            path(
                stroke = SolidColor(Color(0xFF73BE4A)),
                strokeLineWidth = 0.625f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round
            ) {
                moveTo(10.57f, 1.967f)
                curveTo(10.57f, 1.967f, 11.298f, 2.291f, 10.983f, 2.802f)
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(5.787f, 3.973f)
                curveTo(5.84f, 3.882f, 5.951f, 3.854f, 6.035f, 3.912f)
                curveTo(6.119f, 3.969f, 6.144f, 4.09f, 6.091f, 4.181f)
                curveTo(5.99f, 4.356f, 5.937f, 4.596f, 5.937f, 4.905f)
                curveTo(5.937f, 5.013f, 5.857f, 5.1f, 5.758f, 5.1f)
                curveTo(5.659f, 5.1f, 5.578f, 5.013f, 5.578f, 4.905f)
                curveTo(5.578f, 4.528f, 5.647f, 4.217f, 5.787f, 3.973f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(5.505f, 5.758f)
                curveTo(5.505f, 5.866f, 5.425f, 5.953f, 5.326f, 5.953f)
                curveTo(5.227f, 5.953f, 5.146f, 5.866f, 5.146f, 5.758f)
                verticalLineTo(5.201f)
                curveTo(5.146f, 4.808f, 5.208f, 4.498f, 5.338f, 4.271f)
                curveTo(5.391f, 4.18f, 5.502f, 4.152f, 5.586f, 4.209f)
                curveTo(5.67f, 4.267f, 5.695f, 4.387f, 5.643f, 4.479f)
                curveTo(5.553f, 4.634f, 5.505f, 4.875f, 5.505f, 5.201f)
                verticalLineTo(5.758f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(14.678f, 5.497f)
                curveTo(14.678f, 5.605f, 14.758f, 5.693f, 14.857f, 5.693f)
                curveTo(14.956f, 5.693f, 15.037f, 5.605f, 15.037f, 5.497f)
                verticalLineTo(4.941f)
                curveTo(15.037f, 4.547f, 14.975f, 4.237f, 14.845f, 4.011f)
                curveTo(14.792f, 3.92f, 14.681f, 3.892f, 14.597f, 3.949f)
                curveTo(14.513f, 4.006f, 14.488f, 4.127f, 14.54f, 4.218f)
                curveTo(14.63f, 4.373f, 14.678f, 4.614f, 14.678f, 4.941f)
                verticalLineTo(5.497f)
                close()
            }
            path(fill = SolidColor(Color(0xFF73BE4A))) {
                moveTo(15.21f, 6.409f)
                curveTo(15.21f, 6.517f, 15.29f, 6.604f, 15.389f, 6.604f)
                curveTo(15.488f, 6.604f, 15.569f, 6.517f, 15.569f, 6.409f)
                verticalLineTo(5.853f)
                curveTo(15.569f, 5.459f, 15.507f, 5.149f, 15.377f, 4.922f)
                curveTo(15.324f, 4.831f, 15.213f, 4.803f, 15.129f, 4.86f)
                curveTo(15.045f, 4.918f, 15.02f, 5.038f, 15.072f, 5.13f)
                curveTo(15.161f, 5.285f, 15.21f, 5.526f, 15.21f, 5.853f)
                verticalLineTo(6.409f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NorthernMarianaIslandsPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.NorthernMarianaIslands,
            contentDescription = "Northern Mariana Islands Flag"
        )
    }
}
